import { StyleSheet } from 'react-native'

const useMobileStyles = (theme) => StyleSheet.create({
  card: {
    flex: 1,
    marginVertical: 10
  },
  content: {
    borderLeftWidth: 4,
    paddingBottom: 10,
    backgroundColor: theme.CARD_BACKGROUND
  },
  eventInfoContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  rightInfoItem: {
    flex: 1
  },
  leftInfoItem: {
    marginLeft: 10
  },
  typeBadge: {
    width: 75,
    marginVertical: 5,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 3
  }
})

const useLargeStyles = (theme) => StyleSheet.create({
  container: {
    flexDirection: 'row'
  },
  card: {
    flex: 1,
    marginVertical: 10,
    marginRight: 10,
    borderRadius: 5
  },
  content: {
    paddingBottom: 15,
    backgroundColor: theme.CARD_BACKGROUND
  },
  typeBadge: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 3,
    backgroundColor: theme.CHETWODE_BLUE
  },
  hour: {
    alignItems: 'flex-start',
    marginRight: 15,
    marginTop: 10,
    width: 40
  },
  arrow: {
    marginRight: 2
  },
  endHour: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  end: {
    fontSize: 10
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10
  },
  number: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  stops: {
    marginHorizontal: 10
  },
  description: {
    flexDirection: 'row',
    marginVertical: 5,
    marginHorizontal: 10
  },
  location: {
    flex: 1
  },
  address: {
    flex: 1,
    borderLeftWidth: 1,
    paddingLeft: 20
  }
})

export {
  useMobileStyles,
  useLargeStyles
}
